function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { AmexFull } from './assets/brand/AmexFull';
import { AmexFullInverted } from './assets/brand/AmexFullInverted';
import { AmexFullNeutral } from './assets/brand/AmexFullNeutral';
import { CreditKeyFull } from './assets/brand/CreditKeyFull';
import { CreditKeyFullInverted } from './assets/brand/CreditKeyFullInverted';
import { CreditKeyFullNeutral } from './assets/brand/CreditKeyFullNeutral';
import { DinersFull } from './assets/brand/DinersFull';
import { DinersFullInverted } from './assets/brand/DinersFullInverted';
import { DinersFullNeutral } from './assets/brand/DinersFullNeutral';
import { DiscoverFull } from './assets/brand/DiscoverFull';
import { DiscoverFullInverted } from './assets/brand/DiscoverFullInverted';
import { DiscoverFullNeutral } from './assets/brand/DiscoverFullNeutral';
import { EvolveFull } from './assets/brand/EvolveFull';
import { EvolveFullInverted } from './assets/brand/EvolveFullInverted';
import { EvolveFullNeutral } from './assets/brand/EvolveFullNeutral';
import { FlexFull } from './assets/brand/FlexFull';
import { FlexFullInverted } from './assets/brand/FlexFullInverted';
import { FlexFullNeutral } from './assets/brand/FlexFullNeutral';
import { FreshbookFull } from './assets/brand/FreshbookFull';
import { FreshbookFullInverted } from './assets/brand/FreshbookFullInverted';
import { FreshbookFullNeutral } from './assets/brand/FreshbookFullNeutral';
import { IntuitFull } from './assets/brand/IntuitFull';
import { IntuitFullInverted } from './assets/brand/IntuitFullInverted';
import { IntuitFullNeutral } from './assets/brand/IntuitFullNeutral';
import { JPMorganFull } from './assets/brand/JPMorganFull';
import { JPMorganFullInverted } from './assets/brand/JPMorganFullInverted';
import { JPMorganFullNeutral } from './assets/brand/JPMorganFullNeutral';
import { MastercardFull } from './assets/brand/MastercardFull';
import { MastercardFullInverted } from './assets/brand/MastercardFullInverted';
import { MastercardFullNeutral } from './assets/brand/MastercardFullNeutral';
import { MelioFull } from './assets/brand/MelioFull';
import { MelioFullInverted } from './assets/brand/MelioFullInverted';
import { MelioFullNeutral } from './assets/brand/MelioFullNeutral';
import { PciDSSFull } from './assets/brand/PciDSSFull';
import { PciDssFullInverted } from './assets/brand/PciDssFullInverted';
import { PciDSSFullNeutral } from './assets/brand/PciDSSFullNeutral';
import { QuickbooksFull } from './assets/brand/QuickbooksFull';
import { QuickbooksFullInverted } from './assets/brand/QuickbooksFullInverted';
import { QuickbooksFullNeutral } from './assets/brand/QuickbooksFullNeutral';
import { VisaFull } from './assets/brand/VisaFull';
import { VisaFullInverted } from './assets/brand/VisaFullInverted';
import { VisaFullNeutral } from './assets/brand/VisaFullNeutral';
// user facing only
export var brandMap = {
  amex: {
    default: AmexFull,
    neutral: AmexFullNeutral,
    inverted: AmexFullInverted
  },
  diners: {
    default: DinersFull,
    neutral: DinersFullNeutral,
    inverted: DinersFullInverted
  },
  mastercard: {
    default: MastercardFull,
    neutral: MastercardFullNeutral,
    inverted: MastercardFullInverted
  },
  visa: {
    default: VisaFull,
    neutral: VisaFullNeutral,
    inverted: VisaFullInverted
  },
  discover: {
    default: DiscoverFull,
    neutral: DiscoverFullNeutral,
    inverted: DiscoverFullInverted
  },
  melio: {
    default: MelioFull,
    neutral: MelioFullNeutral,
    inverted: MelioFullInverted
  },
  freshbooks: {
    default: FreshbookFull,
    neutral: FreshbookFullNeutral,
    inverted: FreshbookFullInverted
  },
  quickbooks: {
    default: QuickbooksFull,
    neutral: QuickbooksFullNeutral,
    inverted: QuickbooksFullInverted
  },
  'credit-key': {
    default: CreditKeyFull,
    neutral: CreditKeyFullNeutral,
    inverted: CreditKeyFullInverted
  },
  evolve: {
    default: EvolveFull,
    neutral: EvolveFullNeutral,
    inverted: EvolveFullInverted
  },
  intuit: {
    default: IntuitFull,
    neutral: IntuitFullNeutral,
    inverted: IntuitFullInverted
  },
  'pci-dds': {
    default: PciDSSFull,
    neutral: PciDSSFullNeutral,
    inverted: PciDssFullInverted
  },
  'jp-morgan': {
    default: JPMorganFull,
    neutral: JPMorganFullNeutral,
    inverted: JPMorganFullInverted
  },
  flex: {
    default: FlexFull,
    neutral: FlexFullNeutral,
    inverted: FlexFullInverted
  }
};
export var BRAND_SUFFIX_KEYS = {
  default: '-full',
  neutral: '-full-neutral',
  inverted: '-full-inverted'
};
/**
 * @private internal usages only
 */

export var _brandFullMap = Object.entries(brandMap).reduce((acc, _ref) => {
  var [key, value] = _ref;
  return _objectSpread(_objectSpread({}, acc), {}, {
    ["".concat(key).concat(BRAND_SUFFIX_KEYS.default)]: value.default
  });
}, {});
/**
 * @private internal usages only
 */

export var _brandFullNeutralMap = Object.entries(brandMap).reduce((acc, _ref2) => {
  var [key, value] = _ref2;
  return _objectSpread(_objectSpread({}, acc), {}, {
    ["".concat(key).concat(BRAND_SUFFIX_KEYS.neutral)]: value.neutral
  });
}, {});
/**
 * @private internal usages only
 */

export var _brandFullInvertedMap = Object.entries(brandMap).reduce((acc, _ref3) => {
  var [key, value] = _ref3;
  return _objectSpread(_objectSpread({}, acc), {}, {
    ["".concat(key).concat(BRAND_SUFFIX_KEYS.inverted)]: value.inverted
  });
}, {});
export var _brandNameMap = Object.keys(brandMap).reduce((acc, key) => _objectSpread(_objectSpread({}, acc), {}, {
  [key]: {
    default: "".concat(key).concat(BRAND_SUFFIX_KEYS.default),
    neutral: "".concat(key).concat(BRAND_SUFFIX_KEYS.neutral),
    inverted: "".concat(key).concat(BRAND_SUFFIX_KEYS.inverted)
  }
}), {});
export var brand = brandMap;
/**
 * @private internal usages only
 */

export var _brandFull = _brandFullMap; // user facing only

/**
 * @private internal usages only
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
//# sourceMappingURL=brand.js.map